import { FileUploadWorkerInfo } from "./file-upload-worker-info-model";
import { FileMultipartUploadWorkerInfo } from "./file-multipart-upload-worker-info-model";
import { apolloClient } from "../services/vue-apollo";
import {
    GET_VOLUMETRIC_PACK_UPLOAD_URL,
    GET_VOLUMETRIC_PACK_MULTIPART_INFO,
    COMPLETE_VOLUMETRIC_PACK_MULTIPART,
    PROCESS_VOLUMETRIC_PACK,
} from "../graphql/volumetric-pack-queries";

export class VolumetricPackUploadWorkerInfo extends FileUploadWorkerInfo {
    projectId: number;
    scanName: string;

    constructor(file: File, projectId: number, scanName: string) {
        super(file);
        this.projectId = projectId;
        this.scanName = scanName;
    }

    startUpload() {
        apolloClient
            .query({
                query: GET_VOLUMETRIC_PACK_UPLOAD_URL,
                variables: {
                    projectId: this.projectId,
                    scanName: this.scanName
                },
                fetchPolicy: "no-cache",
            })
            .then((res) => {
                this.startSinglePartUpload(res.data.getVolumetricPackUploadUrl.uploadUrl);
            })
            .catch((ex) => {
                console.error(ex);
                if (this.onError) {
                    this.onError(ex);
                }
            });
    }

    completeUpload() {
        this.onStarted?.(`Extracting Volumetric Pack...`);
        apolloClient
            .mutate({
                mutation: PROCESS_VOLUMETRIC_PACK,
                variables: {
                    projectId: this.projectId,
                    scanName: this.scanName,
                },
            })
            .then(() => {
                super.completeUpload();
            })
            .catch((ex) => {
                this.progressMonitor.stopProgressMonitoring();
                this.state.setError(ex);
                if (this.onError) {
                    this.onError(ex);
                }
            });
    }
}

export class VolumetricPackMultipartUploadWorkerInfo extends FileMultipartUploadWorkerInfo {
    projectId: number;
    scanName: string;

    constructor(file: File, projectId: number, scanName: string) {
        super(file);
        this.projectId = projectId;
        this.scanName = scanName;
    }

    startUpload() {
        apolloClient
            .query({
                query: GET_VOLUMETRIC_PACK_MULTIPART_INFO,
                variables: {
                    projectId: this.projectId,
                    scanName: this.scanName,
                    numberOfParts: this.numberOfParts,
                },
                fetchPolicy: "no-cache",
            })
            .then((res) => {
                const info = res.data.getVolumetricPackMultipartInfo;
                this.startMultipartUpload(info);
            })
            .catch((ex) => this.handleError(ex, () => this.startUpload()));
    }

    completeMultipartUpload(eTags: string[]) {
        this.progressMonitor.setComplete();
        this.state.setComplete();
        this.onStarted?.(`Extracting Volumetric Pack...`);

        apolloClient
            .mutate({
                mutation: COMPLETE_VOLUMETRIC_PACK_MULTIPART,
                variables: {
                    projectId: this.projectId,
                    scanName: this.scanName,
                    uploadId: this.uploadId,
                    eTags: eTags.join(","),
                },
            })
            .then(() => {
                return apolloClient.mutate({
                    mutation: PROCESS_VOLUMETRIC_PACK,
                    variables: {
                        projectId: this.projectId,
                        scanName: this.scanName,
                    },
                });
            })
            .then(() => {
                if (this.onComplete) this.onComplete();
            })
            .catch((ex) => {
                if (this.onError) this.onError(ex);
            });
    }
}
